import router from '../router'
// import store from '@/store/store.js'

router.beforeEach((to, from, next) => {
  if (to.path.startsWith('/login')) {
    window.localStorage.removeItem('token')
    next()
  } else {
    let token = window.localStorage.getItem('token')
    // store.dispatch('systemUserGetMenu', store.state)
    if (!token) {
      next()
      next({path: '/login'})
    } else {
      next()
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/permission.js